import React from "react";
import styles from "./index.module.scss";

const Box = ({ children }) => {
  return <div className={styles.box}>{children}</div>;
};

export default Box;
